import utils from '@eitje/utils'
import _ from 'lodash'
import {ALL_ROLES} from './constants'
import {createSmartCachedSelector} from '../selectors'
import {orgEnvsSelector} from '../use_shared'
import {createSelector} from 'reselect'

export const rolesSelector = state => state.settings.roles

export const getRoles = roles => {
	if (roles.includes('admin')) return ALL_ROLES
	if (roles.includes('uren_accorderen')) return [...roles, 'uren_schrijven']
	return roles
}

const hasRoleInAnyEnv = (roleObj, neededRoles, envIds) => {
	neededRoles = utils.alwaysDefinedArray(neededRoles)
	if (!roleObj) roleObj = {}
	const relevantEnvs = _.pick(roleObj, envIds)
	const rolesInEnvs = Object.values(relevantEnvs).flat().uniq()
	const roles = getRoles(rolesInEnvs)
	return neededRoles.some(role => roles.includes(role))
}

export const anyEnvRoleSelector = createSmartCachedSelector(
	rolesSelector,
	(state, roles) => roles,
	(state, roles, envIds) => envIds,
	orgEnvsSelector,
	(roleObj, roles = [], envIds, orgEnvs) => {
		if (!envIds) envIds = orgEnvs.map(e => e.id)
		return hasRoleInAnyEnv(roleObj, roles, envIds)
	},
)

export const roleOrgEnvsSelector = createSmartCachedSelector(
	orgEnvsSelector,
	rolesSelector,
	(state, kind) => kind,
	(envs, roles, kind) => envs.filter(e => hasRole(roles[e.id], kind)),
)

export const hasRole = (roles, key) => {
	if (!roles || !Array.isArray(roles)) return false
	if (roles.includes('admin')) return true
	const requiredRoles = utils.alwaysDefinedArray(key)
	return requiredRoles.some(r => _hasRole(roles, r))
}

export const rolesInAnyEnvSelector = createSelector(rolesSelector, roleObj => {
	const result = {}
	for (const role of ALL_ROLES) {
		const hasRoleInAnyEnv = Object.values(roleObj || {}).some(envRoles => getRoles(envRoles || []).includes(role))
		result[role] = hasRoleInAnyEnv
	}
	return result
})

const _hasRole = (roles, role) => {
	if (role === 'uren_schrijven') return roles.includes('uren_accorderen') || roles.includes(role)
	return roles.includes(role)
}
